<template>
  <MDBContainer fluid>
    <router-view/>
  </MDBContainer>
</template>

<script>
import { provide } from 'vue'
import { mapGetters } from 'vuex'
import { useI18n } from 'vue-i18n'

import {
  MDBContainer
} from '@/index.pro.js'

export default {
  components: {
    MDBContainer
  },
  computed: {
    ...mapGetters([
      'getShowAnnotation'
    ])
  },
  setup () {
    const { t } = useI18n()
    const i18n = {
      capability (key) {
        return this.value('capability_' + key)
      },
      title (key) {
        return this.value('title_' + key)
      },
      value (key) {
        return t('message.' + key)
      }
    }
    provide('i18n', i18n)
    return { i18n }
  }
}
</script>

<style src='../public/css/barlow.css'></style>
<style lang="scss">
@import '../fontawesome/scss/fontawesome.scss';
@import '../fontawesome/scss/solid.scss';
@import '../fontawesome/scss/thin.scss';
@import '~@/assets/css/custom-vars.scss';
@import '~@/../mdb/scss/index.pro.scss';

html, body {
  height: 100%;
  overflow-x: hidden;
}

#app {
  color: #ffffff;
  font-family: 'Barlow', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;

  button {
    &.btn {
      border-radius: 50px;
      padding: 0;
    }

    &.btn-close {
      margin: 0;
    }
  }

  h5.card-title {
    font-size:1.15em;
    font-weight:700
  }

  nav.bg-light {
    background: #ffffff!important;
    opacity: 0.7!important;
  }

  .black {
    color: #000000;
  }

  .card {
    margin: 1em;
  }

  .card-text div {
    font-size: .8em!important;
    text-transform: uppercase;
  }

  .clickable:hover {
    cursor: pointer;
  }

  > .container-fluid {
    height: 100%;
    padding: 0;
  }

  .landing {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .nav-item {
    display: inline-block;
  }

  .nav-tabs .nav-link {
    font-size: 15px;
  }

  .btn, .navbar {
    box-shadow: none;
  }

  .tab-pane {
    margin-top:20px;
  }

  .white {
    color: #ffffff;
  }
}

@media (min-width: 576px) {
  #app {
    .modal-dialog {
      max-width: none;
    }
  }
}
</style>
